import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classNames", "unstyled", "faction", "children", "iconSize", "iconPosition", "labelVariant"];
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Box, createPolymorphicComponent } from '@mantine/core';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './FactionLabel.styles.js';
import { FactionLogo } from '../logos/factions/FactionLogo.js';
var _FactionLabel = forwardRef(function (_ref, ref) {
  var classNames = _ref.classNames,
    unstyled = _ref.unstyled,
    faction = _ref.faction,
    children = _ref.children,
    iconSize = _ref.iconSize,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? "left" : _ref$iconPosition,
    _ref$labelVariant = _ref.labelVariant,
    labelVariant = _ref$labelVariant === void 0 ? "short" : _ref$labelVariant,
    others = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(void 0, {
      name: "FactionLabel",
      classNames: classNames,
      unstyled: unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var label = t("warzone.".concat(labelVariant === "short" ? "faction-short" : "faction", ".").concat(faction));
  return /* @__PURE__ */jsxs(Box, _objectSpread(_objectSpread({
    component: "span",
    ref: ref,
    className: cx(classes.root, classes[faction]),
    unstyled: unstyled
  }, others), {}, {
    children: [iconPosition === "left" ? /* @__PURE__ */jsx(FactionLogo, {
      faction: faction,
      size: iconSize
    }) : /* @__PURE__ */jsx(Fragment, {}), children != null ? children : label, iconPosition === "right" ? /* @__PURE__ */jsx(FactionLogo, {
      faction: faction,
      size: iconSize
    }) : /* @__PURE__ */jsx(Fragment, {})]
  }));
});
_FactionLabel.displayName = "FactionLabel";
var FactionLabel = createPolymorphicComponent(_FactionLabel);
export { FactionLabel };